import React, { useState } from "react";
import { PageHeader } from "@/components/common/PageHeader";
import { AuditViewer } from "@/components/common/AuditViewer";
import { OrgSelect } from "@/components/common/OrgSelect";

export default function PlatformAudit() {
  const [orgId, setOrgId] = useState("all");
  return (
    <div data-testid="platform-audit-page">
      <PageHeader title="Audit Logs" subtitle="Every administrative action across the platform, ready for compliance review." />
      <AuditViewer query={orgId && orgId !== "all" ? `&organisation_id=${orgId}` : ""} />
    </div>
  );
}
